module.exports = __webpack_public_path__ + "img/Postmodernisme_Anne-Karin-Elstad.13b155e6.jpg";